import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import classes from '../products.module.scss';
import Loader from '../../../_common/Loader/Loader';
import Pagination from '../../../_common/Pagination/Pagination';
import { ReactComponent as TimeIcon } from '../../../../assets/icons/time.svg';

const header = [
  {
    name: 'Name',
    path: 'name',
  },
  {
    name: 'NDC',
    path: 'NDC',
  },
  {
    name: 'Schedule',
    path: 'schedule',
  },
  {
    name: 'Package size',
    path: 'packageSize',
  },
  {
    name: 'Quantity',
    path: 'quantity',
  },
  {
    name: 'Cost',
    path: 'cost',
  },
  {
    name: 'Value',
    path: 'value',
  },
  {
    name: 'Actions',
    path: 'Actions',
  },
];

const ProductsTable = ({
  data, page, limit, totalPage, onChange, otc,
}) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  return (
    !data.length && !loading
      ? <div className={classes.notResult}>No Data Found</div>

      : (
        <div className={classes.table_pagination_wrapper}>
          { loading && <Loader />}

          <div className={classes.table_wrapper}>

            <table>

              <thead>
                <tr>
                  {header.map((h) => (
                    <th key={h.name}>{h.name}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {data.map((d) => (
                  <tr key={d.id}>
                    {header.map((h) => (
                      h.path === 'Actions'
                        ? (
                          <td key={h.name} onClick={() => navigate(`${d.id}/inventory`)}>
                            <TimeIcon className={classes.icon} />
                          </td>
                        )

                        : (
                          <td
                            onClick={() => navigate(`${d.id}/edit?otc=${otc}`)}
                            key={h.name}
                          >
                            {d[h.path] ? d[h.path] : '-'}
                          </td>
                        )
                    ))}

                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />

        </div>
      ));
};

ProductsTable.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  otc: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ProductsTable;
